<template lang="pug">
  mixer-uploads-list(v-if="!isMobile")
  mixer-uploads-list-mobile(v-else)
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'

const MixerUploadsList = () => import('./MixerUploadsList')
const MixerUploadsListMobile = () => import('./MixerUploadsListMobile')

export default {
  name: 'MixerLoads',

  mixins: [adaptationMixin],

  components: {
    MixerUploadsList,
    MixerUploadsListMobile,
  }
}
</script>
